import { type ReactNode } from 'react';
import { pb } from '@/core/api';

type Props = {
  collectionId: string;
  recordId: string;
  files: string[];
};

function gridCls(count: number): string {
  if (count === 1) return 'grid grid-cols-1 gap-sm';
  return 'grid grid-cols-2 gap-sm';
}

function thumbUrl(
  collectionId: string,
  recordId: string,
  file: string
): string {
  const record = { id: recordId, collectionId } as Parameters<
    typeof pb.files.getURL
  >[0];
  return pb.files.getURL(record, file, { thumb: '1200x0' });
}

const TILE_WRAP =
  'relative overflow-hidden rounded-md border border-white/[0.06] bg-surface';
const TILE_IMG = 'aspect-video w-full object-cover';
const TILE_OVERLAY =
  'absolute inset-0 flex items-center justify-center bg-black/60 text-lg font-medium text-white';

function Tile(p: {
  collectionId: string;
  recordId: string;
  file: string;
  overlay?: number | undefined;
}): ReactNode {
  return (
    <div className={TILE_WRAP}>
      <img
        src={thumbUrl(p.collectionId, p.recordId, p.file)}
        alt=""
        loading="lazy"
        className={TILE_IMG}
      />
      {p.overlay && p.overlay > 0 && (
        <div className={TILE_OVERLAY}>+{p.overlay}</div>
      )}
    </div>
  );
}

export function FeedCardMedia({
  collectionId,
  recordId,
  files,
}: Props): ReactNode {
  if (!files || files.length === 0) return null;
  const visible = files.slice(0, 4);
  const extra = files.length - visible.length;
  return (
    <div className={`mt-md ${gridCls(visible.length)}`}>
      {visible.map((f, i) => (
        <Tile
          key={f}
          collectionId={collectionId}
          recordId={recordId}
          file={f}
          overlay={i === visible.length - 1 ? extra : undefined}
        />
      ))}
    </div>
  );
}
